<template>
  <!-- <v-text-field
    v-model="search_terms"
    outlined
    dense
    flat
    hide-details
    label="Search contracts"
    prepend-inner-icon="mdi-magnify"
    class="ml-5 py-2 mr-1 font-regular"
    clearable
    rounded
    color="rgb(255, 20, 99)"
    @keyup.enter="keywordSearch(search_terms)"
    
  ></v-text-field> -->
    <v-autocomplete
      outlined
        dense
        flat
        hide-details
        dark
        label="History"
        class="ml-5 py-2 mr-1 menu-item-text"
        style="min-width: 300px;"
        v-model="selectedUrl"
        :items="filteredUrls"
        item-text="description"
        prepend-inner-icon="mdi-history"
        item-value="url"
        hide-no-data
        hide-selected
        return-object
        color="rgb(255, 20, 99)"
        @input="onUrlSelect"
        clearable
      >
        <template v-slot:item="data">

            <v-row>
              <v-col cols="2">
                <span v-if="data.item.route_name" class="menu-item-text mr-5 font-weight-bold">{{ data.item.route_name }}</span>
              </v-col>
              <v-col cols="10" class="pl-0">
                <span class="menu-item-text">{{ data.item.description || data.item.url }}</span>
              </v-col>
            </v-row>
            

        </template>
      </v-autocomplete>
</template>

<script>
import { getHistory } from "./APIManager.js";

export default {
  components: {
    //TenderFilters
  },

  data() {
    return {
      search_terms: "",
      disable_nav: false,
      showMenu: false,
      userHistory: []
      //show_login_menu: false
    };
  },
  created() {},

  mounted() {

    this.getRecentSearches();

  },

  computed: {
    filteredUrls() {
      return this.userHistory.map((item) => ({
        description: item.description,
        url: this.extractRelativeUrl(item.url),
        route_name: item.route_name
      }));
    },
  },

  methods: {

    async getRecentSearches() {
      this.loading = true;

      this.userHistory = await getHistory();
      //console.log(this.userHistory)
      this.loading = false;
    },

    onUrlSelect(selectedUrl) {
      if (selectedUrl && selectedUrl.url) {
        this.$router.push(selectedUrl.url);
      }
    },

    extractRelativeUrl(fullUrl) {
      try {
        const url = new URL(fullUrl);
        return url.pathname + url.search;
      } catch (error) {
          //console.error("Invalid URL:", fullUrl);
          return fullUrl; // Return the original URL if parsing fails
      }
    },

    showFilters() {
      ////////////console.log("SHOW FILTERS");
      this.showMenu = !this.showMenu;
      //bus.$emit("hideFilters", false);
    },

    keywordSearch(search_terms) {
                                                         
      var query = { tender: [search_terms] };

      if (this.$route.query.viewIndex){       
        query["viewIndex"] = this.$route.query.viewIndex;
      }
      this.$router.push({ path: "/search", query: query });
      this.search_terms = "";
      //bus.$emit("global-search", query);
    },

    disabled() {
      if (localStorage.getItem("isLoggedIn") == "1") {
        this.disable_nav = false;
        return this.disable_nav;
      } else {
        this.disable_nav = true;
        return this.disable_nav;
      }
    }
  }
};
</script>
<style>

.menu-item-text {
  font-size: 13px; /* Adjust the text size as needed */
}

</style>
